import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'assets/third-party/apex-chart.css';
import 'assets/third-party/react-table.css';
import App from './App';
import { ConfigProvider } from 'contexts/ConfigContext';

const container = document.getElementById('root');

if (container) {
  createRoot(container).render(
    <ConfigProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ConfigProvider>
  );
}
